<script>

    import Events from './components/Events.svelte';
    import Filter from './components/Filter.svelte';
    import { filter } from './components/filter.js';
    import { slugify } from './components/helpers.js';
    import { scrollToElement } from './helpers.js';

    export let title;
    export let events = [];

    function getLocations( events ){
        let locations = {};
        events.forEach( e => {
            let location = e.location;
            if( !location.lat || !location.lon ){
                return;
            }
            let slug = slugify( location.city );
            locations[slug] = {
                ...location,
                slug,
                lat: parseFloat( location.lat ),
                lon: parseFloat( location.lon ),
            };
        });
        return Object.values( locations );
    }

    let locations = getLocations( events );

    let header;
    function handleFilter( f ){
        f = f.map( x => x.city );
        filter.set( f );
        scrollToElement( header );
    }

    function listHeight( element ){
        header = element;
        setListMinHeight();
    }
    function setListMinHeight(){
        let listMinHeight = window.innerHeight - header.offsetHeight;
        document.documentElement.style.setProperty('--list-min-height', `${listMinHeight}px`);
    }
    function handleResize() {
        setListMinHeight();
        setTimeout(() => {
            setListMinHeight();
        }, 200);
        setTimeout(() => {
            setListMinHeight();
        }, 400);
        setTimeout(() => {
            setListMinHeight();
        }, 600);
    }

</script>

<svelte:window on:resize={handleResize} />

<section id="tour">

    <figure>
        <img src="/assets/images/map.png" alt="Schmyt Live in Deutschland, Österreich und Schweiz" />
    </figure>

    <Filter {locations} on:change={()=>scrollToElement( header )} />

    <div class="wrapper">

        <header use:listHeight>
            <h3>{title}</h3>
            <div class="font-s right">
                <button on:click={()=> handleFilter([]) }>alle ausblenden</button>
                <button on:click={()=> handleFilter(locations) }>alle anzeigen</button>
            </div>
        </header>

        <Events {events} />

    </div>

</section>
    
<style>

    .wrapper {
        margin-top: -100vh;
        margin-left: 1rem;
        margin-right: 1rem;
    }
    @media (min-width: 700px){
        .wrapper {
            margin-left: 5%;
            margin-right: calc( 5% - 1rem );
        }
    }

    header {
        z-index: 100;
        position: sticky;
        top: 0;
        width: 100%;
        padding: 1rem 0;
        display: flex;
        border-bottom: 1px solid currentColor;
        justify-content: space-between;
    }
    header button {
        font-size: 1.4rem;
        text-decoration: underline;
    }

    section {
        position: relative;
    }
    figure {
        position: sticky;
        top: 0;
        z-index: 100;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        mix-blend-mode: difference;
        height: 100vh;
    }
    h3 {
        min-width: 25%;
    }
    figure img {
        width: 100vw;
        height: 100vw;
    }
    @media (orientation: landscape){
        figure img {
            width: 100vh;
            height: 100vh;
        }
    }

</style>